import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.fmTicketsAddHead'),
      "subtitle": _vm.$i18n_t('Common.fmTicketsAddHeadInfoText')
    }
  }), _c(VRow, {
    staticClass: "n20-mainrow"
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "lg": "12"
    }
  }, [_c(VForm, {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "buttons": _vm.buttonsMainForm,
      "form": _vm.$refs.form,
      "offset": "30"
    }
  }, [_c('p', {
    staticClass: "mt-4"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.selectDtwin')) + "\n          ")]), _c(VRow, {
    staticClass: "mt-4",
    attrs: {
      "justify": "space-between",
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-dtwin-finder', {
    attrs: {
      "disabled": _vm.loading,
      "requiredErrorText": _vm.$i18n_t('IS.FM.Ticket.twinRequired'),
      "required": ""
    },
    on: {
      "dtwin-selected": _vm.dtwinSelected
    },
    model: {
      value: _vm.twinId,
      callback: function ($$v) {
        _vm.twinId = $$v;
      },
      expression: "twinId"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.types,
      "label": _vm.$i18n_t('Common.type'),
      "rules": _vm.comboRules,
      "color": _vm.color,
      "disabled": _vm.loading,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "autocomplete": "off",
      "item-text": "name",
      "item-value": "id",
      "attach": "",
      "required": "",
      "return-object": "",
      "validate-on-blur": ""
    },
    model: {
      value: _vm.type,
      callback: function ($$v) {
        _vm.type = $$v;
      },
      expression: "type"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.subjects,
      "label": _vm.$i18n_t('Common.subject'),
      "rules": _vm.comboRules,
      "color": _vm.color,
      "disabled": _vm.loading,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "autocomplete": "off",
      "item-text": "subjectText",
      "item-value": "subjectId",
      "attach": "",
      "required": "",
      "return-object": "",
      "validate-on-blur": ""
    },
    model: {
      value: _vm.ticket.subject,
      callback: function ($$v) {
        _vm.$set(_vm.ticket, "subject", $$v);
      },
      expression: "ticket.subject"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "label": _vm.$i18n_t('Common.comment'),
      "color": _vm.color,
      "disabled": _vm.loading,
      "name": "comment",
      "value": "",
      "hint": "",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.comments.comment,
      callback: function ($$v) {
        _vm.$set(_vm.comments, "comment", $$v);
      },
      expression: "comments.comment"
    }
  })], 1)], 1), _c('p', {
    staticClass: "px-2 pt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.uploadAPictureText')))]), _c(VRow, {
    attrs: {
      "justify": "space-between"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VRow, {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('media-upload', {
    ref: "mediaUpload",
    attrs: {
      "type": 'image'
    },
    on: {
      "getFile": _vm.getFile,
      "rotateImage": _vm.rotateImage
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };